<template>
  <div class="sv-page">
    <header class="sv-page-header">
      <div>
        <span class="sv-page-header__eyebrow">Histórico pesquisável</span>
        <h1>Gravações</h1>
        <p>Encontre, analise e reproduza as conversas armazenadas pela operação.</p>
      </div>
    </header>

    <CardsRecordings />
    <RecordingsTable />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import CardsRecordings from "../../components/Recordings/CardsRecordings.vue";
import RecordingsTable from "../../components/Recordings/RecordingsTable.vue";

export default defineComponent({
  name: "RecordingsPage",
  components: {
    RecordingsTable,
    CardsRecordings,
  },
});
</script>
